<template>
  <div class="full-page-slide-wrapper">
    <swiper :options="swiperOption" ref="mySwiper">
      <!-- slides -->
      <swiper-slide v-for="(item,index) in data" :key="index"><img @click="toDetail(item.id)" :src="item.img1" alt></swiper-slide>

      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>
 
<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import data from "@/assets/data.js"
export default {
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      data,

      swiperOption: {
        direction: 'horizontal',
        clickable: true,
        // loop: true,
        speed: 1000,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        slidesPerView: 'auto',
        centeredSlides: true,
        observer:true,
        observeParents:true,
        spaceBetween: 15,
        // 如果需要分页器
        pagination: {
          el: '.swiper-pagination',
          bulletActiveClass: 'slide_dot_active',
          bulletClass: 'slide_dot'
        },
      }
    }
  },
  mounted () {
  },
  methods: {
    toDetail(id){
      this.$router.push({name: 'redWoodDetail',params: { id: id}})
    },
  }
}
</script>
<style lang="scss">
.full-page-slide-wrapper {
  width: 100%;
  // height: 3.68rem;
  padding-top: .36rem;
  box-sizing: content-box;
  // padding-bottom: 10px;
  position: relative;
  .swiper-container {
    width: 100%;
    height: 100%;
    padding-bottom: 30px;
    .swiper-wrapper {
      display: flex;
      align-items: center;
    }
    .swiper-slide {
      width: calc(100% - 1rem);
      border-radius: 5px;
      // box-shadow: 4px 4px 2px rgba(124,216,147,0.5);
    }
    .swiper-slide-prev {
      // height: 90% !important;
      transform: scale(1,0.8)
    }
    .swiper-slide-next {
      // height: 90% !important;
      transform: scale(1,0.8)
    }
  }
  img {
    object-fit: fill;
    height: 100%;
    width: 100%;
    border-radius: 5px;
  }
  .slide_dot {
    display: inline-block;
    margin: 5px;
    width: .12rem;
    height: .12rem;
    background-color: #7cd893;
    border-radius: .06rem;
    opacity: 0.8;
  }
  .swiper-pagination {
    bottom: -0.2rem !important;
  }
  .slide_dot_active {
    border-radius: 5px;
    background: #00cc33;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/swiper.vue